import { ActionInfo } from "./ActionInfoTypes";

// -----
// *** UPGRADE ACTIONS ***
// -----

export const Upgrade_BrickPack_SlopedBricksPartOne: ActionInfo = {
  id: "upgrade_brickpack_sloped_bricks_part_one",
  type: "Upgrade",
  title: "Sloped Bricks #1 (+5%)",
  details: "Increase find percentage for all bricks in Sloped Bricks #1 by 5%",
  cost: [
    {
      brickId: "3005",
      baseChangeValue: 100,
    },
    {
      brickId: "3004",
      baseChangeValue: 100,
    },
    {
      brickId: "3003",
      baseChangeValue: 60,
    },
    {
      brickId: "3001",
      baseChangeValue: 60,
    },
    {
      brickId: "4286",
      baseChangeValue: 15,
    },
    {
      brickId: "6091",
      baseChangeValue: 15,
    },
  ],
  costIncrement: 1,
  outcome: [
    {
      brickId: "brickpack_sloped_bricks_part_one",
      baseChangeValue: 5,
    },
  ],
  actionVisibility: [
    {
      actionId: "increase_capacity_brickpack_sloped_bricks_part_one",
    },
    {
      actionId: "increase_capacity_brickpack_minifig_utensils_part_one",
    },
    {
      actionId: "increase_capacity_brickpack_bionicles_part_one",
    },
  ],
  isBrickpack: false,
};

export const Upgrade_BrickPack_MinifigUtensilsPartOne: ActionInfo = {
  id: "upgrade_brickpack_minifig_utensils_part_one",
  type: "Upgrade",
  title: "Minifig Utnls #1 (+5%)",
  details:
    "Increase find percentage for all bricks in Minifig Utensils #1 by 5%",
  cost: [
    {
      brickId: "3010",
      baseChangeValue: 100,
    },
    {
      brickId: "3710",
      baseChangeValue: 100,
    },
    {
      brickId: "3022",
      baseChangeValue: 100,
    },
    {
      brickId: "3040",
      baseChangeValue: 20,
    },
    {
      brickId: "2752",
      baseChangeValue: 20,
    },
    {
      brickId: "3039",
      baseChangeValue: 15,
    },
    {
      brickId: "30228",
      baseChangeValue: 15,
    },
    {
      brickId: "6246a",
      baseChangeValue: 15,
    },
  ],
  costIncrement: 1,
  outcome: [
    {
      brickId: "brickpack_minifig_utensils_part_one",
      baseChangeValue: 5,
    },
  ],
  actionVisibility: [
    {
      actionId: "increase_capacity_brickpack_sloped_bricks_part_one",
    },
    {
      actionId: "increase_capacity_brickpack_minifig_utensils_part_one",
    },
    {
      actionId: "increase_capacity_brickpack_bionicles_part_one",
    },
  ],
  isBrickpack: false,
};

export const Upgrade_BrickPack_BioniclesPartOne: ActionInfo = {
  id: "upgrade_brickpack_bionicles_part_one",
  type: "Upgrade",
  title: "Bionicles #1 (+5%)",
  details: "Increase find percentage for all bricks in Bionicles #1 by 5%",
  cost: [
    {
      brickId: "3003",
      baseChangeValue: 120,
    },
    {
      brickId: "3001",
      baseChangeValue: 120,
    },
    {
      brickId: "3020",
      baseChangeValue: 120,
    },
    {
      brickId: "3660",
      baseChangeValue: 25,
    },
    {
      brickId: "30390",
      baseChangeValue: 25,
    },
    {
      brickId: "4449",
      baseChangeValue: 15,
    },
    {
      brickId: "3835",
      baseChangeValue: 15,
    },
    {
      brickId: "x346",
      baseChangeValue: 7,
    },
    {
      brickId: "42074",
      baseChangeValue: 7,
    },
  ],
  costIncrement: 1,
  outcome: [
    {
      brickId: "brickpack_bionicles_part_one",
      baseChangeValue: 5,
    },
  ],
  actionVisibility: [
    {
      actionId: "increase_capacity_brickpack_sloped_bricks_part_one",
    },
    {
      actionId: "increase_capacity_brickpack_minifig_utensils_part_one",
    },
    {
      actionId: "increase_capacity_brickpack_bionicles_part_one",
    },
  ],
  isBrickpack: false,
};

export const Upgrade_BrickPack_AnimalsPartOne: ActionInfo = {
  id: "upgrade_brickpack_animals_part_one",
  type: "Upgrade",
  title: "Animals #1 (+5%)",
  details: "Increase find percentage for all bricks in Animals #1 by 5%",
  cost: [
    {
      brickId: "3003",
      baseChangeValue: 500,
    },
    {
      brickId: "3001",
      baseChangeValue: 500,
    },
    {
      brickId: "3020",
      baseChangeValue: 500,
    },
    {
      brickId: "6086",
      baseChangeValue: 10,
    },
    {
      brickId: "30103",
      baseChangeValue: 10,
    },
    {
      brickId: "6772-1",
      baseChangeValue: 5,
      type: "set",
    },
  ],
  costIncrement: 1,
  outcome: [
    {
      brickId: "brickpack_animals_part_one",
      baseChangeValue: 5,
    },
  ],
  actionVisibility: [],
  isBrickpack: false,
};

export const Upgrade_BrickPack_MinifigUtensilsPartTwo: ActionInfo = {
  id: "upgrade_brickpack_minifig_utensils_part_two",
  type: "Upgrade",
  title: "Minifig Utnls #2 (+5%)",
  details:
    "Increase find percentage for all bricks in Minifig Utensils #2 by 5%",
  cost: [
    {
      brickId: "3010",
      baseChangeValue: 750,
    },
    {
      brickId: "3710",
      baseChangeValue: 750,
    },
    {
      brickId: "3022",
      baseChangeValue: 750,
    },
    {
      brickId: "30464",
      baseChangeValue: 10,
    },
    {
      brickId: "6772-1",
      baseChangeValue: 10,
      type: "set",
    },
    {
      brickId: "8534-1",
      baseChangeValue: 10,
      type: "set",
    },
  ],
  costIncrement: 1,
  outcome: [
    {
      brickId: "brickpack_minifig_utensils_part_two",
      baseChangeValue: 5,
    },
  ],
  actionVisibility: [],
  isBrickpack: false,
};

export const Upgrade_BrickPack_BioniclesPartTwo: ActionInfo = {
  id: "upgrade_brickpack_bionicles_part_two",
  type: "Upgrade",
  title: "Bionicles #2 (+5%)",
  details: "Increase find percentage for all bricks in Bionicles #2 by 5%",
  cost: [
    {
      brickId: "3005",
      baseChangeValue: 1000,
    },
    {
      brickId: "3004",
      baseChangeValue: 1000,
    },
    {
      brickId: "3003",
      baseChangeValue: 1000,
    },
    {
      brickId: "3001",
      baseChangeValue: 1000,
    },
    {
      brickId: "92084",
      baseChangeValue: 10,
    },
    {
      brickId: "80674",
      baseChangeValue: 10,
    },
    {
      brickId: "8534-1",
      baseChangeValue: 10,
      type: "set",
    },
    {
      brickId: "4866-1",
      baseChangeValue: 10,
      type: "set",
    },
  ],
  costIncrement: 1,
  outcome: [
    {
      brickId: "brickpack_bionicles_part_two",
      baseChangeValue: 5,
    },
  ],
  actionVisibility: [],
  isBrickpack: false,
};

export const Upgrade_BrickPack_CircularBricks: ActionInfo = {
  id: "upgrade_brickpack_circular_bricks",
  type: "Upgrade",
  title: "Circular Bricks (+5%)",
  details: "Increase find percentage for all bricks in Circular Bricks by 5%",
  cost: [
    {
      brickId: "3010",
      baseChangeValue: 750,
    },
    {
      brickId: "3003",
      baseChangeValue: 750,
    },
    {
      brickId: "3022",
      baseChangeValue: 750,
    },
    {
      brickId: "32570",
      baseChangeValue: 30,
    },
    {
      brickId: "32505",
      baseChangeValue: 30,
    },
    {
      brickId: "3960",
      baseChangeValue: 3,
    },
    {
      brickId: "6014b",
      baseChangeValue: 3,
    },
    {
      brickId: "4866-1",
      baseChangeValue: 20,
      type: "set",
    },
  ],
  costIncrement: 1,
  outcome: [
    {
      brickId: "brickpack_circular_bricks",
      baseChangeValue: 5,
    },
  ],
  actionVisibility: [],
  isBrickpack: false,
};

export const Upgrade_BrickPack_MinifigHair: ActionInfo = {
  id: "upgrade_brickpack_minifig_hair",
  type: "Upgrade",
  title: "Minifig Hair (+5%)",
  details: "Increase find percentage for all bricks in Minifig Hair by 5%",
  cost: [
    {
      brickId: "32575",
      baseChangeValue: 40,
    },
    {
      brickId: "32574",
      baseChangeValue: 40,
    },
    {
      brickId: "3960",
      baseChangeValue: 30,
    },
    {
      brickId: "41531",
      baseChangeValue: 30,
    },
    {
      brickId: "3901",
      baseChangeValue: 7,
    },
    {
      brickId: "62696",
      baseChangeValue: 7,
    },
    {
      brickId: "6772-1",
      baseChangeValue: 15,
      type: "set",
    },
    {
      brickId: "4432-1",
      baseChangeValue: 10,
      type: "set",
    },
  ],
  costIncrement: 1,
  outcome: [
    {
      brickId: "brickpack_minifig_hair",
      baseChangeValue: 5,
    },
  ],
  actionVisibility: [],
  isBrickpack: false,
};

export const Upgrade_BrickPack_TechnicBricks: ActionInfo = {
  id: "upgrade_brickpack_technic_bricks",
  type: "Upgrade",
  title: "Technic Bricks (+5%)",
  details: "Increase find percentage for all bricks in Technic Bricks by 5%",
  cost: [
    {
      brickId: "3005",
      baseChangeValue: 4000,
    },
    {
      brickId: "26139",
      baseChangeValue: 30,
    },
    {
      brickId: "42444",
      baseChangeValue: 30,
    },
    {
      brickId: "73230",
      baseChangeValue: 7,
    },
    {
      brickId: "3701",
      baseChangeValue: 7,
    },
    {
      brickId: "71766-1",
      baseChangeValue: 5,
      type: "set",
    },
  ],
  costIncrement: 1,
  outcome: [
    {
      brickId: "brickpack_technic_bricks",
      baseChangeValue: 5,
    },
  ],
  actionVisibility: [],
  isBrickpack: false,
};

export const Upgrade_BrickPack_MinifigHeadgear: ActionInfo = {
  id: "upgrade_brickpack_minifig_headgear",
  type: "Upgrade",
  title: "Minifig Headgear (+5%)",
  details: "Increase find percentage for all bricks in Minifig Headgear by 5%",
  cost: [
    {
      brickId: "26139",
      baseChangeValue: 30,
    },
    {
      brickId: "53981",
      baseChangeValue: 30,
    },
    {
      brickId: "87991",
      baseChangeValue: 30,
    },
    {
      brickId: "3648",
      baseChangeValue: 20,
    },
    {
      brickId: "73230",
      baseChangeValue: 20,
    },
    {
      brickId: "3898",
      baseChangeValue: 7,
    },
    {
      brickId: "30202",
      baseChangeValue: 7,
    },
    {
      brickId: "x164",
      baseChangeValue: 7,
    },
    {
      brickId: "71766-1",
      baseChangeValue: 5,
      type: "set",
    },
  ],
  costIncrement: 1,
  outcome: [
    {
      brickId: "brickpack_minifig_headgear",
      baseChangeValue: 5,
    },
  ],
  actionVisibility: [],
  isBrickpack: false,
};
